module.exports = __webpack_public_path__ + "img/rev.mng.ba4dd122.svg";